import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/NavOutline.tsx
import React from "react";
var SvgNavOutline, NavOutline_default;
var init_NavOutline = __esm({
  "src/icons/NavOutline.tsx"() {
    SvgNavOutline = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "m4.965 5.096 3.546 12.41 3.04-6.08 5.637-2.255L4.965 5.096ZM2.899 2.3l18.806 6.268a.5.5 0 0 1 .028.939L13 13l-4.425 8.85a.5.5 0 0 1-.928-.086L2.26 2.911a.5.5 0 0 1 .64-.61h-.001Z"
        }
      )
    );
    NavOutline_default = SvgNavOutline;
  }
});

export {
  NavOutline_default,
  init_NavOutline
};
